// The assessment validation writes "'<Field>' is required but missing." for every empty mandatory
// field. The red field row already says that, so the summary box and the row skip it and show only
// other blocking problems (below minimum, not allowed, ...). QA #4.
const MISSING_RE = /^'.+' is required but missing\.$/;

export const isMissingFieldMessage = (message?: string | null): boolean => !!message && MISSING_RE.test(message);

export const nonMissingBlocking = <T extends { message: string }>(messages: T[]): T[] =>
  messages.filter((m) => !isMissingFieldMessage(m.message));

/** Field names behind the generated "'<Field>' is required but missing." messages, for the one summary line. */
export const missingFieldNames = (messages: { message: string }[]): string[] =>
  messages.flatMap((m) => { const hit = /^'(.+)' is required but missing\.$/.exec(m.message); return hit ? [hit[1]] : []; });

/** The button hint says WHAT to do; the field names live in the summary box, not here. */
export const shortBlockedReason = (reason?: string | null): string | undefined | null =>
  reason && /^Fill in the required fields in the Assessment Summary:/.test(reason)
    ? 'Fill in the required fields in the Assessment Summary.'
    : reason;
